import { useConsult } from '../../hooks/useConsult';
import ConsultMap from './ConsultMap';
import ConsultChat from './ConsultChat';
import CoveragePanel from './CoveragePanel';
import CallOverlay from './CallOverlay';
import '../../styles/ConsultPage.css';
import '../../styles/CallOverlay.css';

// "Fiber spark" - a small radiating-node icon for the brand mark.
// Hand-tuned SVG; rendered at 16px inside the indigo gradient tile.
const BrandSpark = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"
       strokeLinecap="round" width="16" height="16" aria-hidden="true">
    <circle cx="12" cy="12" r="2.4" fill="currentColor" stroke="none" />
    <path d="M12 4v2M12 18v2M4 12h2M18 12h2" />
    <path d="M6.3 6.3l1.4 1.4M16.3 16.3l1.4 1.4M6.3 17.7l1.4-1.4M16.3 7.7l1.4-1.4" opacity=".55" />
  </svg>
);

export default function ConsultPage() {
  const consult = useConsult();
  return (
    <div className="consult-page">
      <header className="consult-header">
        <div className="consult-brand">
          <span className="consult-brand-mark"><BrandSpark /></span>
          <div className="consult-brand-text">
            <h1 className="consult-brand-title">اپراتور هوشمند</h1>
            <span className="consult-brand-sub">مشاورهٔ فیبر نوری</span>
          </div>
        </div>
        <span className="consult-status" aria-live="polite">
          <span className="consult-status-dot" aria-hidden="true" />
          آنلاین
        </span>
      </header>

      {consult.error && (
        <div
          className="consult-error"
          role="button"
          tabIndex={0}
          aria-label="بستن خطا"
          onClick={consult.clearError}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') consult.clearError(); }}
        >
          {consult.error}
        </div>
      )}

      <main className="consult-main">
        <section className="consult-pane consult-pane-map" aria-label="نقشه">
          <ConsultMap consult={consult} />
          <CoveragePanel consult={consult} />
        </section>
        <section className="consult-pane consult-pane-chat" aria-label="گفتگو">
          <ConsultChat consult={consult} />
        </section>
      </main>

      {consult.callState !== 'idle' && <CallOverlay call={consult.call} />}
    </div>
  );
}
